import React from 'react';
import MemoryMapFlow from './MemoryMapFlow';

const sections = [
  {
    title: 'Definite Integral Calculation',
    descriptionPoints: [
      { text: 'Primitive Table', subpoints: [] },
      { text: 'Integration by Parts', subpoints: [] },
      {
        text: 'Substitution: rewrite as a derivative of composition of two functions',
        subpoints: ['Fraction', 'Root Square', 'Trigonometric functions'],
      },
    ],
    link: '/advanced/integrals/definite_integral_calculation',
  },
  {
    title: 'Double Integral',
    descriptionPoints: [
      { text: 'Calculation one by one', subpoints: [] },
      { text: 'Separate the two integrals', subpoints: [] },
    ],
    link: '/advanced/integrals/double_integral',
  },
  {
    title: 'Improper Integral',
    descriptionPoints: [
      {
        text: 'Convergence Study by using:',
        subpoints: [
          'Criterions',
          'Comparision',
          'Taylor expansion',
          'Inequalities',
          'Comparison Integral-Series',
        ],
      },
      {
        text: 'Integral Calculation',
        subpoints: ['Integral Calculation Technics'],
      },
    ],
    link: '/advanced/integrals/improper_integral',
  },
  {
    title: 'Integral with Multiple Variables',
    descriptionPoints: [
      {
        text: 'Convergence Types:',
        subpoints: ['Simple', 'Absolute', 'Uniform', 'Normal'],
      },
      {
        text: 'Interchange of integral with:',
        subpoints: ['Sum', 'Derivative'],
      },
      {
        text: 'Integral Calculation',
        subpoints: [
          'Integral Calculation Technics',
          'Calculate derivative first',
          'Calculate primitve first',
          'Use differential equation',
        ],
      },
    ],
    link: '/advanced/integrals/integral_with_multiple_variables',
  },
];

const IntegralsMemoryMap = () => (
  <MemoryMapFlow title="Integrals" sections={sections} />
);

export default IntegralsMemoryMap;
